module.exports = __webpack_public_path__ + "static/media/Result__success.23ba572f.svg";